import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/study-group/$study-group-id/info")({
  beforeLoad: ({ params }) => {
    // Info is now presented via modal from StudyGroupLayout.
    // Keep URL compatibility by redirecting old deep links to stream.
    throw redirect({
      to: "/study-group/$study-group-id/stream",
      params,
      replace: true,
    });
  },
  component: () => <div>Redirecting to stream...</div>,
});
